import React from 'react'
import Layout from '../layouts/index.js'
import Contact from '../components/contact/contact.js'
import trimaxmobilekit from '../../static/assets/trimex-outdoor-mobile-tours.pdf'
import ImageSlider from '../components/hero/index'

function importAll(r) {
  return r.keys().map(r)
}

const images = importAll(
  require.context(
    '../images/mobile-tour-page',
    false,
    /\.(png|jpe?g)$/ // png, jpg, jpeg
  )
)
class LunchTruckPage extends React.Component {
  render() {
    return (
      <Layout head={{ title: 'Mobile Tour' }}>
        <section id="title">
          <div className="container">
            <div className="row">
              <div className="col text-center">
                <h1 className="heading-title">Mobile Tour</h1>
              </div>
            </div>
          </div>
        </section>

        <section id="mobile-tour" className="text-center">
          <div className="container mb-5">
            <div className="row">
              <div className="col">
                <div
                  className="mb-5 "
                  style={{ maxWidth: '800px', margin: '0 auto' }}
                >
                  <p className="section-p">
                    <strong>Mobile Tours Provided!</strong> Below is an overview
                    of how it works
                  </p>
                  <p className="section-p">
                    <strong>Overview:</strong> Food Trucks. All shapes and sizes
                    can be chartered for your event. We set everything up from
                    start to finish.
                  </p>
                  <p className="section-p">
                    We wrap them with your graphics. You can equip them with
                    monitors, let us know what you want. Wow factor 10!
                  </p>
                </div>
                <div className="container" style={{ maxWidth: '1800px' }}>
                  <div className="carousel-container">
                    <ImageSlider images={images} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container">
            <div className="row">
              <div className="col">
                <div className="container">
                  {/* <img src={mobilekit} className="img-fluid" alt="mediakit" /> */}
                  <div className="d-flex justify-content-center">
                    <a
                      class="link-btn-green"
                      href={trimaxmobilekit}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      Download
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Contact />
      </Layout>
    )
  }
}
export default LunchTruckPage
